import React, { useState, useEffect, useRef } from "react";
import variables from "../../themes/base/styles/variables";
import "./styles.scss";
import useResponsive from "../../core/hooks/useResponsive";

const VideoPlayerStyle = {
  videoElementStyle: {
    height: variables.fullHeight,
    backgroundColor: "transparent",
    position: "relative",
    objectFit: "contain",
  },
  markerStyle: {
    position: "absolute",
    bottom: "calc(2rem - .75rem)",
    transform: "translate(-50%, -50%)",
    pointerEvents: "none",
  },
  markerIconStyle: {
    width: variables.markerSize,
    height: variables.markerSize,
  },
};
const VideoPlayer = ({ mediaToPreview, mediaUrl }) => {
  const [markers, setMarkers] = useState([]);
  const [showMarkers, setShowMarkers] = useState(false);
  const [duration, setDuration] = useState(null);
  const videoElementRef = useRef();
  const responsive = useResponsive();

  const handleFocusOut = () => {
    setShowMarkers(false);
  };

  const handleFocusIn = () => {
    setShowMarkers(true);
  };

  useEffect(() => {
    setFlagsToMarkers(mediaToPreview?.redFlag, true);
    setFlagsToMarkers(mediaToPreview?.greenFlag, false);
  }, [mediaToPreview]);

  const setFlagsToMarkers = (flags, redFlag) => {
    flags?.forEach((flagItem) => {
      setMarkers((prevMarkers) => [
        ...prevMarkers,
        {
          time: parseInt(flagItem),
          icon: redFlag ? "/icons/red_marker.svg" : "/icons/green_marker.svg",
        },
      ]);
    });
  };

  useEffect(() => {
    videoElementRef.current = document.getElementById("video-player");
    videoElementRef.current.currentTime = 1e101;
    videoElementRef.current.disablePictureInPicture = true;

    if (!videoElementRef.current.duration && !duration) {
      videoElementRef.current.addEventListener("durationchange", function () {
        if (videoElementRef.current.duration !== Infinity) {
          setDuration(videoElementRef.current.duration);
          videoElementRef.current.currentTime = 0;
          videoElementRef.current.play();
          videoElementRef.current.removeEventListener(
            "durationchange",
            function () {}//NOSONAR
          );
        }
      });
    }
    videoElementRef.current.addEventListener(
      "timeupdate",
      function () {
        videoElementRef.current.setAttribute("controls", "controls");
      },
      false
    );
  }, [mediaUrl]);

  return (
    <>
      <video
        src={mediaUrl}
        controls={true}
        width={window.innerWidth - (responsive.isSm ? 232 : 30)}
        style={VideoPlayerStyle.videoElementStyle}
        id="video-player"
        onMouseEnter={handleFocusIn}
        onMouseLeave={handleFocusOut}
      />
      {showMarkers &&
        markers.map((marker) => (
          <div
            key={marker.time}
            style={{
              ...VideoPlayerStyle.markerStyle,
              ...{
                left: `${(marker.time / duration) * 100}%`,
                display:
                  (!videoElementRef?.current?.duration ||
                    videoElementRef?.current?.duration === Infinity) &&
                  "none",
              },
            }}
          >
            <img
              src={marker.icon}
              alt="marker-icon"
              style={VideoPlayerStyle.markerIconStyle}
            />
          </div>
        ))}
    </>
  );
};

export default VideoPlayer;
